module.exports = __webpack_public_path__ + "img/shipment-succeeded.8b022419.svg";